import type { FormSchemaDef } from '@/components/common/form/types';

/**
 * 診断フォームのスキーマ定義
 * 旧 diagnostic.ts の個別定数を統合した宣言的なフォーム定義
 */
export const DIAGNOSTIC_FORM_SCHEMA: FormSchemaDef = {
  version: '1.0.0',
  steps: [
    {
      id: 'budget_kpi',
      title: '予算とKPI',
      questions: [
        {
          id: 'budget',
          type: 'SINGLE_SELECT',
          label: '月額の広告予算を教えてください',
          description: '最適なソリューションの提案に活用します',
          required: true,
          options: [
            { id: 'under_5m', label: '500万円以下' },
            { id: '5m_10m', label: '500〜1,000万円' },
            { id: '10m_30m', label: '1,000〜3,000万円' },
            { id: '30m_50m', label: '3,000〜5,000万円' },
            { id: 'over_50m', label: '5,000万円以上' },
          ],
        },
        {
          id: 'kpis',
          type: 'MULTI_SELECT',
          label: '達成したいKPIを選択してください',
          description: '(複数選択可)',
          required: true,
          options: [
            { id: 'cpa_kpi', label: 'CPA（獲得単価）の改善' },
            { id: 'roas_kpi', label: 'ROAS（広告費用対効果）の向上' },
            { id: 'cv_kpi', label: 'CV数（コンバージョン数）の拡大' },
            { id: 'awareness_kpi', label: '認知度・リーチの拡大' },
            { id: 'brand_search_kpi', label: '指名検索数の増加' },
          ],
        },
      ],
    },
    {
      id: 'media',
      title: '媒体状況',
      questions: [
        {
          id: 'media_status',
          type: 'CONDITIONAL_SELECT',
          label: '各媒体の状況を教えてください',
          description: '実施状況に応じて最適な提案を行います',
          required: true,
          items: [
            { id: 'listing', label: 'リスティング広告' },
            { id: 'sns', label: 'SNS広告' },
            { id: 'display', label: 'ディスプレイ広告' },
            { id: 'youtube', label: 'YouTube' },
            { id: 'video_other', label: '動画広告（その他）' },
            { id: 'tv_cm', label: '地上波CM' },
            { id: 'tver', label: 'TVer' },
            { id: 'ctv', label: 'Connected TV' },
            { id: 'taxi', label: 'タクシー広告' },
            { id: 'ooh', label: 'OOH（屋外広告）' },
            { id: 'event', label: 'イベント' },
          ],
          primaryOptions: [
            { id: 'active', label: '実施中' },
            { id: 'past', label: '以前やっていた' },
            { id: 'interested', label: '興味あり' },
            { id: 'none', label: 'なし' },
          ],
          conditionalRules: [
            {
              triggerValue: 'active',
              secondaryLabel: '月額予算',
              secondaryOptions: [
                { id: 'under_5m', label: '500万円以下' },
                { id: '5m_10m', label: '500〜1,000万円' },
                { id: '10m_30m', label: '1,000〜3,000万円' },
                { id: '30m_50m', label: '3,000〜5,000万円' },
                { id: 'over_50m', label: '5,000万円以上' },
              ],
            },
          ],
        },
      ],
    },
    {
      id: 'challenges',
      title: '課題と満足度',
      questions: [
        {
          id: 'challenges',
          type: 'MULTI_SELECT',
          label: '現在の広告運用の課題を教えてください',
          description: '(複数選択可)',
          required: true,
          options: [
            { id: 'cpa', label: 'CPA・獲得コストが高騰している' },
            { id: 'unknown', label: '効果が見えない・測定できていない' },
            { id: 'creative', label: 'クリエイティブや戦略の見直しが必要' },
            { id: 'search', label: '指名検索や認知が不足している' },
            { id: 'start', label: '新規媒体に興味はあるが踏み出せていない' },
          ],
        },
        {
          id: 'satisfaction',
          type: 'SINGLE_SELECT',
          label: '現在の広告運用に満足していますか？',
          required: true,
          options: [
            { id: 'satisfied', label: '満足している' },
            { id: 'normal', label: '普通' },
            { id: 'dissatisfied', label: '不満がある' },
          ],
        },
      ],
    },
  ],
};
